import React, { useEffect } from 'react';
import { Switch, Route, NavLink, Redirect, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import { addMetricSearchBtn } from 'utils/addMetrics';
import isEmpty from 'lodash/isEmpty';
import Button from 'ati-ui-react/components/Button';
import getSearchAdvertType from 'utils/getSearchAdvertType';
import noWipeAwayQs from 'utils/noWipeAwayQs';
import deleteUrlParameter from 'utils/deleteUrlParameter';

import searchLocation from 'constants/searchLocation';
import SaleSearchTab from './components/SaleSearchTab';
import RentSearchTab from './components/RentSearchTab';
import PurchaseSearchTab from './components/PurchaseSearchTab';
import ProposalsPurchaseTab from './components/ProposalsPurchaseTab';
import ToFormButton from './components/ToFormButton';
import SaveFilterBtn from './components/SaveFilterLink';

import {
  SearchContainer,
  LinksTab,
  TabsContent,
  SearchBtn,
  Reset,
  CabinetAndFormButtonContainer,
} from './SearchStyles';

const Search = observer((props) => {
  const { path } = props.match;
  const { pathname } = props.location;

  const location = useLocation();
  const advertType = getSearchAdvertType();

  const {
    findTrucksStore: {
      getTrucksResults,
      initialSearchState,
      setTabLocation,
      searchState,
      isRentSearch,
      pagination,
      fieldsValues,
      setAdvertType,
      fields,
    },
    geoSearchStore,
    profileStore: { isUser },
    loginContactInfoStore: { getLoginContactInfo },
  } = useStores();

  useEffect(() => {
    getLoginContactInfo();
  }, []);

  const handleInitialSearchState = async () => {
    await initialSearchState();
    await getTrucksResults();
  };

  useEffect(() => {
    setAdvertType(advertType);
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      geoSearchStore.resetSuggestions();
      pagination.resetPage();
    };
  }, []);

  useEffect(() => {
    setTabLocation(searchLocation[pathname]);
  }, [pathname]);

  const handleClickSearch = () => {
    addMetricSearchBtn(isRentSearch);
    pagination.resetPage();
    deleteUrlParameter('page');
    getTrucksResults();
    document.getElementById('search-result').scrollIntoView({
      behavior: 'smooth',
    });
  };

  const qs = () => {
    return noWipeAwayQs({ ordering: fields.ordering });
  };

  return (
    <SearchContainer>
      <LinksTab>
        <NavLink
          onClick={handleInitialSearchState}
          to={`${path}${qs()}`}
          className="link"
          exact
          activeClassName="selected"
        >
          Продажа
        </NavLink>
        <NavLink
          onClick={handleInitialSearchState}
          to={`${path}/rent${qs()}`}
          className="link"
          exact
          activeClassName="selected"
        >
          Аренда
        </NavLink>
        <NavLink
          onClick={handleInitialSearchState}
          to={`${path}/proposals-purchase${qs()}`}
          className="link"
          exact
          activeClassName="selected"
        >
          Заявки на покупку
        </NavLink>
        <NavLink
          onClick={handleInitialSearchState}
          to={`${path}/proposals-rent${qs()}`}
          className="link"
          exact
          activeClassName="selected"
        >
          Заявки на аренду
        </NavLink>
        <CabinetAndFormButtonContainer>
          <div className="button-form">
            <ToFormButton path={props} />
          </div>
        </CabinetAndFormButtonContainer>
      </LinksTab>

      <TabsContent>
        <Switch>
          <Route exact path={`${path}`} component={SaleSearchTab} />
          <Route exact path={`${path}/rent`} component={RentSearchTab} />
          <Route exact path={`${path}/proposals-purchase`} component={PurchaseSearchTab} />
          <Route exact path={`${path}/proposals-rent`} component={ProposalsPurchaseTab} />
          <Redirect to={`${path}`} />
        </Switch>
      </TabsContent>

      <SearchBtn>
        <div className="actions">
          <div className="actions-wrapper">
            {isUser && <SaveFilterBtn />}
            {!isEmpty(fieldsValues) && (
              <div className="reset-container">
                <Reset role="presentation" onClick={handleInitialSearchState}>
                  Очистить
                </Reset>
              </div>
            )}
            <Button className="btn" isLoading={searchState.isRequest} onClick={handleClickSearch}>
              Найти объявления
            </Button>
          </div>
        </div>
      </SearchBtn>
    </SearchContainer>
  );
});

export default Search;
